import 'date-fns';
import React, { Fragment, useState } from 'react';
import DateFnsUtils from '@date-io/date-fns';
import { sv } from "date-fns/locale";
import { KeyboardDatePicker,KeyboardDateTimePicker,MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import { isUndefined } from 'lodash';
import IntlMessages from 'util/IntlMessages';
import moment from 'moment-timezone'
function SlutDatePicker(props) {
  const [selectedDate, setselectedDate] = useState(new Date());
  const [Lable, setLable] = useState(isUndefined(props.lable)?"Slutdatum":props.lable);
  const handleDateChange = (date) => {
    setselectedDate(date)
    props.handleChange(moment(date).tz("Europe/Stockholm").format("YYYY-MM-DD HH:mm"))
  }

  return (
    <MuiPickersUtilsProvider locale={sv} utils={DateFnsUtils}>
      <Fragment>
        <KeyboardDateTimePicker
          cancelLabel={<IntlMessages id="Cancel"/>}
          inputVariant="outlined"
          ampm={false}
          invalidDateMessage={<IntlMessages id="Date.inValid"/>}
          label={`${Lable}:`}
          size="small"
          name="Slutdatum"
          format="yyyy-MM-dd"
          variant="dialog"
          fullWidth
          disabled={isUndefined(props.disabled)?false:props.disabled}
          value={selectedDate}
          onChange={handleDateChange}
          animateYearScrolling
          KeyboardButtonProps={{
            "class": "px-0 m-0 btn btn-sm"
           }}
        />
      </Fragment>
    </MuiPickersUtilsProvider>
  );
}

export default SlutDatePicker;